import script from "./SpeV2Main.vue?vue&type=script&setup=true&lang=js"
export * from "./SpeV2Main.vue?vue&type=script&setup=true&lang=js"

import "./SpeV2Main.vue?vue&type=style&index=0&id=3c586d7c&scoped=true&lang=css"
import "./SpeV2Main.vue?vue&type=style&index=1&id=3c586d7c&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c586d7c"]])

export default __exports__